import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPlusThin = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 416 416",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#create-new-create-new)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M240 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h144v144c0 17.7 14.3 32 32 32s32-14.3 32-32V240h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H240V32Z"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "create-new-create-new",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h416v416H0z"
		})
	}) })]
});
export default SvgIconPlusThin;
